import { useEffect, useState } from "react";
import ProductVersion from "../account/ProductVersion";
import { getDomainFromUrl } from "../../utils/domainUtilities";

const Support = () => {

  const [supportBox, setSupportBox] = useState(null);
  const DefaultBox = (
    <div className="Support">
      <div className="modal fade" id="contactInfoModal" tabIndex="-1" role="dialog" aria-labelledby="CustomerSupportModal" aria-hidden="false" >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title" id="myModalLabel"> Need help? </div>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-content-body">
                <div className="left-panel-sm w-full">
                  <i className="bi bi-headset b-clr"></i>
                </div>
                <div className="sp-margin6">
                  <div className="content-wrapper">
                    <label>Phone: </label>
                    <div className="contact-content">1-888-470-9913</div>
                  </div>
                  <div className="content-wrapper">
                    <label>Email: </label>
                    <div className="contact-content word-set">
                      <a href="mailto:support@secureexsolutions.com">
                        support@secureexsolutions.com
                      </a>
                    </div>
                  </div>
                  <div className="content-wrapper">
                    <label>Product: </label>
                    <ProductVersion />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  useEffect(() => {

    const initializeSupport = async () => {
      try {
        const customSupport = await import(
          "../../custom_portal/" + getDomainFromUrl(window.location.hostname) + "/components/account/Support"
        );

        setSupportBox(customSupport.default());
      } catch {
        setSupportBox(DefaultBox);
      }
    };

    initializeSupport();
  }, []);
  return <div>{supportBox}</div>;
};

export default Support;